import {show} from "cartovistaExtend/appTools/Alerts";
import {downloadShapefile} from "cartovistaExtend/utils/ServerRequests";
import {str2Uint8Array, downloadBlob} from "cartovistaExtend/utils/ServerUtils";
import "styles/DownloadShapefile.css";

var downloadBtnGroupHtml = '<div class="dropdown" style="float:left; font-family:Arial, Helvetica, Verdana, sans-serif;">' +
                                '<button id="DownloadShapefileTool_btn" class="k-button k-button-icon dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false" title="Télécharger en format Shapefile">' +
                                    '<span class="cv-icon bi bi-download">' +
                                '</button>' +
                                '<ul class="dropdown-menu"><strong style="padding:5px 10px;">Couche(s) :</strong></ul>' +
                            '</div>';

export default class DownloadShapefile {
	constructor() {
		this._$downloadBtnGroup = $(downloadBtnGroupHtml);
        window.cartovista.addOneTimeEventListener(window.cartovista.EVENTS.MAP_LOADED + "_" + C.MAP.ID, this._onCartoVistaMapLoaded, this);
    }

   _onCartoVistaMapLoaded(evt) {
        this._map = window.cartovista.getMap(C.MAP.ID);
        $(".cv-headerAction button:eq(1)").after(this._$downloadBtnGroup);
        this._initDownloadDropDownChoices();
    };

    _initDownloadDropDownChoices() {
        _.forEach(C.APP_TOOLS.DOWNLOAD_SHAPEFILE.LAYERS, function(layerConfig) {
            var $choice = $('<li><a class="dropdown-item" href="javascript:void(0);">' + layerConfig.NAME + '</a></li>');
            this._$downloadBtnGroup.find(".dropdown-menu").append($choice);
            $choice.click(this._onDownloadChoiceClicked.bind(this, layerConfig));
        }.bind(this));
    };

    _onDownloadChoiceClicked(layerConfig) {
        if (this._layerHasFeatures(layerConfig)) {
            downloadShapefile(layerConfig, this._getQueryExpression(layerConfig)).then(function(result) {
                fetch(result.url).then(function(response){
                    response.blob().then(function(blob){
                        var filename = layerConfig.NAME + "_CS_" + C.APP_TOOLS.AUTH_SESSION.USER.CD_CS + ".zip";
                        const blobUrl = URL.createObjectURL(blob);
                        var a = document.createElement("a");
                        a.href = blobUrl;
                        a.download = filename;
                        a.style.display = "none";
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    })
                })
            });
        } else {
            show(layerConfig.DOWNLOAD_ACTIVE_SCENARIO_ONLY ? "DownloadShapefileTool_layerHasNoFeatureScenario" : "DownloadShapefileTool_layerHasNoFeature", {"layerName" : layerConfig.NAME, "scenario" : C.THEMESETS_ELEMENTS[this._map._scenarioId].TITLE});
        }
    };

    _layerHasFeatures(layerConfig) {
        var bool;
        this._map.getLayer(layerConfig.LAYER_ID).getFeatures(null, function(result) {
            bool = typeof layerConfig.FILTER_GEOMETRY_TYPE != "undefined" ? _.some(result.features, {"geometryType" : layerConfig.FILTER_GEOMETRY_TYPE}) : result.features.length ? true : false;
        }, this, layerConfig.DOWNLOAD_ACTIVE_SCENARIO_ONLY ? true : false);
        return bool;
    };

    _getQueryExpression(layerConfig) {
        if (layerConfig.DOWNLOAD_ACTIVE_SCENARIO_ONLY) {
            return {
                "LOGICAL_OPERATOR" : null,
                "QUERIES" : [
                    {"FIELD" : "SCENARIO", "OPERATOR" : "=", "VALUE" : this._map._scenarioId},
                ]
            };
        }
    };
}
